type SelectionItem = {
  title: string
  file: string
  language: string
}

export const ADD_SELECTION = 'ADD_SELECTION'
export const REMOVE_SELECTION = 'REMOVE_SELECTION'
export const CLEAR_SELECTION = 'CLEAR_SELECTION'

interface AddSelection {
  type: typeof ADD_SELECTION
  item: SelectionItem
}

interface RemoveSelection {
  type: typeof REMOVE_SELECTION
  title: string
}

interface ClearSelection {
  type: typeof CLEAR_SELECTION
}

export type SelectionActionTypes = AddSelection | RemoveSelection | ClearSelection

export interface SelectionState {
  selection: SelectionItem[]
}
